import { toast } from "sonner";

/**
 * Share an article/card via the native share sheet (mobile: WhatsApp, Instagram…)
 * with a copy-to-clipboard fallback on desktop.
 */
export async function shareArticle({ title, text, path, ogPath }) {
  // ogPath: crawler-friendly URL carrying the article's own photo for WhatsApp/social previews
  const url = `${window.location.origin}${ogPath || path}`;
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (e) {
      if (e?.name === "AbortError") return; // user closed the sheet
    }
  }
  try {
    await navigator.clipboard.writeText(`${title} — ${url}`);
    toast.success("Link copied — paste it in WhatsApp or Instagram to share");
  } catch {
    toast.error("Couldn't copy the link — copy the address bar instead");
  }
}
